import React from 'react'

const Step_two = ({ prevStep, nextStep, allGender, onFilterChange }) => {
    return (
        <>
            <section className='quizformsection'>

                <div className='navigationdiv'>
                    <div className='row'>
                        <div className='col-12 text-center'>
                            <p className='formstepps'>2/05</p>
                        </div>
                        <div className='col-12 text-center'>
                            <div className='formtitlediv'>
                                <h2 className='formtitle'>What are you looking for?</h2>
                                <button className="backbtn" type="button" onClick={prevStep} >
                                    <img className='backicon' src={process.env.PUBLIC_URL + '/assets/images/quick-quiz/backbtn.png'} />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='productsdiv'>
                    <div className='row justify-content-center'>
                        {allGender?.slice(0, 2).map((data) => (
                            <div className='col-lg-4 col-sm-6  mb-3'>
                                <div className='productcard' onClick={() => { onFilterChange("gender", { id: data?.id, name: data.name }); nextStep() }}>
                                    <img className='bgimg' src={process.env.PUBLIC_URL + '/assets/images/quick-quiz/frame1.png'} />

                                    <div className='oevrlaycont'>
                                        <div className='prodimgdiv'>
                                            <img className='prod_img' src={process.env.REACT_APP_IMAGE_URL + data?.image} />

                                            {/* <img className='prod_img' src={process.env.PUBLIC_URL + (data?.name == "Female" ? '/assets/images/quick-quiz/women.png' : '/assets/images/quick-quiz/man.png')} /> */}
                                        </div>
                                        <p className='prodname'> {data?.name}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                        {/* <div className='col-lg-4 col-sm-6  mb-3'>
                            <div className='productcard'>
                                <img className='bgimg' src={process.env.PUBLIC_URL + '/assets/images/quick-quiz/frame1.png'} />

                                <div className='oevrlaycont'>
                                    <div className='prodimgdiv'>
                                        <img className='prod_img' src={process.env.PUBLIC_URL + '/assets/images/quick-quiz/women.png'} />
                                    </div>
                                    <p className='prodname'>Women's style</p>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-4 col-sm-6  mb-3'>
                            <div className='productcard'>
                                <img className='bgimg' src={process.env.PUBLIC_URL + '/assets/images/quick-quiz/frame1.png'} />

                                <div className='oevrlaycont'>
                                    <div className='prodimgdiv'>
                                        <img className='prod_img' src={process.env.PUBLIC_URL + '/assets/images/quick-quiz/man.png'} />
                                    </div>
                                    <p className='prodname'>Men's style</p>
                                </div>
                            </div>
                        </div>*/}
                    </div>
                </div>

                <div className='nextbuttondiv'>
                    <button className='nextbtn' onClick={nextStep}>No preference</button>
                </div>


            </section>
        </>

    )
}

export default Step_two